import { render, staticRenderFns } from "./StudentTermOfUsePage.vue?vue&type=template&id=106e4b60&"
import script from "./StudentTermOfUsePage.vue?vue&type=script&lang=ts&"
export * from "./StudentTermOfUsePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports